import { memo, useMemo, type VFC } from 'react'
import { LoadingPanel, NoReportsSVG } from '@panwds/react-ui'
import { stateRef } from '../../framework/store'
import { MSP_PATH_PREFIX, MULTI_TENANT_PATH_PREFIX_REGEX } from '../../framework/constants'
import './LoadingPlaceholder.scss'

let showInitialLoadingProgress = true
export const removeLoadingProgress = () => {
  showInitialLoadingProgress = false
}

const docTitle = document.title
const InitialLoadingPlaceholder: VFC<{}> = () => {
  const [message, viewMode] = useMemo(() => {
    const { pathname } = window.location
    if (!showInitialLoadingProgress || pathname === '/') {
      return []
    }
    if (!MULTI_TENANT_PATH_PREFIX_REGEX.test(pathname)) {
      const auth = stateRef.current.auth
      if (auth?.tsg_id && auth.tsgs?.hasParentOrSubTenants(auth.tsg_id)) {
        return [`Loading ${auth?.tsg_name || docTitle}`, 'SINGLE TENANT VIEW']
      }
      return [`Loading ${docTitle}`]
    }
    else if (pathname.startsWith(MSP_PATH_PREFIX)) {
      return ['Loading Multitenant Summary', 'MULTITENANT VIEW']
    }
    return []
  }, [])

  const loadingProgressCls = (() => {
    const { navRoutes, auth, main, leftMainNavigation } = stateRef.current
    if (auth.loading) {
      return 30
    }
    if (auth.tsgs && auth.instances) {
      if (navRoutes && !navRoutes.loading && leftMainNavigation && !leftMainNavigation.initializing) {
        return 100
      }
      if (main?.infoLoaded) {
        return 70
      }
      return 50
    }
    return 1
  })()

  return (
    <div className='spk-load-container panwds-tw3'>
      <NoReportsSVG width={120} height={120} />
      {message && <div className='spf-mt-4 spf-text-default dark:spf-text-dark-bg'>{message}</div>}
      {viewMode && <div className='spf-mt-4 spf-rounded-full spf-border spf-px-2 spf-p-y-1 spf-text-xs spf-border-solid spf-border-gray-500 spf-text-gray-600 dark:spf-text-gray-300'>{viewMode}</div>}
      <div className={`spf-mt-4 sparky-loading-progress sparky-loading-progress-${loadingProgressCls}`} />
    </div>
  )
}

const SpinnerLoadingPlaceholderComp: VFC<{}> = () => (
  <div className='spk-load-container panwds-tw3'>
    <LoadingPanel />
  </div>
)

export const SpinnerLoadingPlaceholder = memo(SpinnerLoadingPlaceholderComp)

const LoadingPlaceholder: VFC<{}> = () => {
  if (showInitialLoadingProgress && stateRef.current.auth) {
    return <InitialLoadingPlaceholder />
  }
  return (
    <SpinnerLoadingPlaceholder />
  )
}

export default memo(LoadingPlaceholder)
